export const isHTMLEmpty = function (html) {
  if (!html) {
    return true
  }
  const $html = $(`<div>${html}<div>`)
  $html.find("p:empty,div:empty,span:empty").remove()
  html = $.trim($html.html())
  return html.length < 1
}
